import { Helmet } from "react-helmet";
import drImage from "../images/dr-tayfun-giyik-2.jpeg";

function About() {
  return (
    <section id="about">
      <Helmet>
        <title>Dr. Tayfun Giyik - Hakkında | Medikal Estetik Uygulamaları</title>
        <meta
          name="description"
          content="İstanbul Tıp Fakültesi mezunu Dr. Tayfun Giyik - medikal estetik uygulamaları ve tedavi yaklaşımı hakkında bilgi."
        />
        <link
          rel="canonical"
          href="https://www.drtayfungiyik.com.tr/hakkimda"
        />
        <meta property="og:title" content="Dr. Tayfun Giyik - Hakkında" />
        <meta
          property="og:description"
          content="İstanbul Tıp Fakültesi mezunu Dr. Tayfun Giyik ile medikal estetik uygulamalar."
        />
      </Helmet>
      <h2 className="section-title">Doktorunuz</h2>
      <div className="about-content">
        <img src={drImage} alt="Dr. Tayfun Giyik" className="doc-image" />
        <div className="about-text">
          <p>
            İstanbul Tıp Fakültesi mezunu (2007-2013) Dr. Tayfun Giyik, medikal
            estetik alanında aldığı eğitimlerle, her hastasını bireysel ve doğal
            bir güzellik anlayışıyla değerlendirir.
          </p>
          <p>
            Ana prensibi, "En iyi estetik, fark edilmeyendir" ilkesidir. Yüz
            harmonisi ve oranlar üzerine odaklanarak, kişiye özel, abartıdan
            uzak, doğal sonuçlar elde etmeyi hedefler.
          </p>
          <div className="highlight-box">
            <strong>Uygulama Alanları:</strong> Yüz Dolgusu & Şekillendirme,
            Botoks Uygulamaları, Cilt Gençleştirme (Mezoterapi, PRP), Sıvı Yüz
            Germe.
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
